import { EMPTY_STRING, DATE_FORMAT } from "./constants";
import moment from 'moment';

export const isNullOrEmpty = (data) =>{
    return(null === data || undefined === data || !data.toString() || EMPTY_STRING === data.toString().trim());
}

export const formatCurrency = (data) =>{
    return isNullOrEmpty(data) ? null : (
        isWholeNumber(data) ? parseInt(data).toLocaleString('en') : Number(data).toLocaleString('en', {minimumFractionDigits: 2,maximumFractionDigits: 2})
    );
}

export const formatPlaceValue = (data) =>{
    return isNullOrEmpty(data) ? null : data.toLocaleString('en');
}

export const isValidNumber = (number) =>{
    return (!isNaN(number));
}

export const isDecimal = (number) =>{
    return (!isNaN(parseInt(number, 10)))
}

export const getCurrentDate = () =>{
    return moment(moment().format(DATE_FORMAT));
}

export const isWholeNumber = (value) =>{
    return (value - Math.floor(value)) === 0;
}